<template>
  <div>
    <home-header></home-header>
    <inside-page-bannar></inside-page-bannar>
    <div class="content-left">
      <div class="page-width">
        <inside-page-left></inside-page-left>
      </div>
    </div>
    <div class="content page-width">
      <div class="content-right">
        <div class="rightnavs">
          <h2 class="localtion"><i class="iconfont icon-weizhi margin-right-10"></i>当前位置：<router-link to="/">首页</router-link>>><router-link to="/">专业</router-link></h2>
        </div>
        <major-list :arrs="arrs"></major-list>
      </div>
      <div class="clearfix"></div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import HomeHeader from '@/common/components/Header'
import InsidePageBannar from '@/common/components/InsidePageBannar'
import InsidePageLeft from '@/common/components/InsidePageLeft'
import Foot from '@/common/components/Foot'
import Fade from '@/common/fade/FadeAnimation'
import MajorList from './components/MajorList'
import axios from 'axios'
export default {
  name: 'Major',
  components: {
    HomeHeader,
    InsidePageBannar,
    Foot,
    MajorList,
    InsidePageLeft,
    Fade
  },
  data: function () {
    return {
      arrs: []
    }
  },
  
  methods: {
    getDetailInfo () {
      axios.get('http://localhost:8080/static/mock/index.json').then(this.handleGetDataSucc)
    },
    handleGetDataSucc (res) {
      res = res.data
      if (res.ret && res.data) {
        const data = res.data
        this.arrs = data.course
      }
    }
  },
  mounted () {
    this.getDetailInfo()
  }
}
</script>
<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  .page-width{
    width:$pageWidth;
    margin:0 auto;
    .content-right{
      margin-top:30px;
      .localtion{
        line-height 30px;
        border-bottom:1px solid $borderColor;
        margin-bottom:20px;
      }
    }
  }
  .content-left{
    background:#f7f6f6;
  }
</style>



// WEBPACK FOOTER //
// src/pages/major/Index.vue